import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { Subject, takeUntil } from 'rxjs';
import { SolChecklistPartOneComponent } from '../sol-checklist-part-one/sol-checklist-part-one.component';
import { SolChecklistPartTwoComponent } from '../sol-checklist-part-two/sol-checklist-part-two.component';
import { SolChecklistPartThreeComponent } from '../sol-checklist-part-three/sol-checklist-part-three.component';
import { OptionalWorkflowDirective } from '../../../Directives/optional-workflow-directive';
import { ReviewDetailTabsService } from '../../../lib/review-detail-tabs.service';
import { SolChecklistElectricalComponent } from '../sol-checklist-electrical/sol-checklist-electrical.component';
import { Constants } from '../../../constants/constants';
import { ReviewService } from '../../../services/review.service';
import { CostReviewElectricalAttributes } from '../../../models/CostReviewElectricalAttributes';

@Component({
  selector: 'app-sol-complete-checklist-tab',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    SolChecklistPartOneComponent,
    SolChecklistPartTwoComponent,
    SolChecklistPartThreeComponent,
    OptionalWorkflowDirective,
    SolChecklistElectricalComponent
  ],
  templateUrl: './sol-complete-checklist.component.html',
  styleUrl: './sol-complete-checklist.component.scss'
})

export class SolCompleteChecklistTabComponent implements OnInit, OnDestroy {
  optionalWorkflowCondition: boolean = false;
  business: string = '';
  isNewElectricalChecklist: boolean = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly reviewTabService: ReviewDetailTabsService,
    private readonly reviewService: ReviewService
  ) {
  }

  ngOnInit(): void {
   this.optionalWorkflowCondition = this.reviewTabService.getOptionalWorkflowAndEstimateType()?.optionalWorkflow || false;

    this.updateChecklistTemplateType();

    this.getBusiness();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBusiness(): void {
    this.reviewTabService.getBusiness$
      .pipe(takeUntil(this.destroy$))
      .subscribe(business => {
      this.business = business;
      this.updateChecklistTemplateType();
      });
  }

  private updateChecklistTemplateType(): void {
    const reviewData = this.reviewService.costReviewDetails?.reviewObject;
    const isElectricalBusiness = this.business === Constants.BUSINESS_ELECTRICAL;

    if (!isElectricalBusiness) {
      this.isNewElectricalChecklist = false;
      return;
    }

    if (reviewData && 'costReviewScopeOfWork' in reviewData) {
      this.isNewElectricalChecklist = true;
      return;
    }

  }

}
